import { useEffect, useState } from 'react';

import { InlineAlert } from './ui/inline-alert';

export function AuthError() {
    const [error, setError] = useState<{ error: string; description: string } | null>(null);

    useEffect(() => {
        // Parse URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const errorParam = urlParams.get('error');
        const errorDescription = urlParams.get('error_description');

        if (errorParam) {
            setError({
                error: errorParam,
                description: errorDescription || 'An authentication error occurred.',
            });

            // Clear the URL parameters after displaying
            const newUrl = window.location.pathname;
            window.history.replaceState({}, document.title, newUrl);
        }
    }, []);

    if (!error) return null;

    return (
        <InlineAlert tone="error" title="Authentication error">
            <p>{error.description}</p>
        </InlineAlert>
    );
}
